var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBedarfscheck = function SvgBedarfscheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#637384",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    clipPath: "url(#Bedarfscheck_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.76 6.26a2.39 2.39 0 1 0 0-4.78 2.39 2.39 0 0 0 0 4.78ZM20.59 12a3.84 3.84 0 0 0-3.83-3.83A3.84 3.84 0 0 0 12.93 12M8.15 16.78l3.62.91q.21.023.42 0a1.7 1.7 0 0 0 1.7-1.7v-.12A1.7 1.7 0 0 0 13 14.4l-3.33-1.64a7.2 7.2 0 0 0-5.5-.39L2.41 13H.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 17.74h1.91l6.47-1.85q.226-.06.46-.06a1.68 1.68 0 0 1 1.66 1.67v.11a1.67 1.67 0 0 1-1 1.53L15 22a5.8 5.8 0 0 1-2.32.49 5.8 5.8 0 0 1-1.38-.17l-7-1.74H.5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Bedarfscheck_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgBedarfscheck;